import { Payload } from "@neworbit/redux-helpers";
import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { getStatistics } from "./StatisticsApi";

import * as actions from "./actionTypes";
import { Statistics } from "./models";

export type StatisticsAction =
    ({ type: typeof actions.LOAD_STATISTICS_SUCCESS } & Payload<Statistics>);

export const loadStatisticsSuccess = (payload: Statistics): StatisticsAction => ({
    payload,
    type: actions.LOAD_STATISTICS_SUCCESS
});

export function loadStatistics() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_STATISTICS, getStatistics());
        dispatch(loadStatisticsSuccess(result));
    };
}
